<style lang="scss">
  @import 'scss/main';
</style>
<template>
  <search-wrapper
    :asynchronous-results="true"
    :cludo-customer-id="2541"
    :cludo-engine-id="11278"
    :initially-load-results="true"
    :per-page="500"
    :search-url="searchUrl"
    :searchPayload.prop="searchPayload"
    ref="searchWrapper"
  >
    <section class="programmes">

      <!-- Main --> 
      <div class="programmes__main">

        <!-- Meta -->
        <div v-if="!loadingResults" class="programmes__meta">
          
          <!-- Results Count -->
          <p><strong>{{ resultsCount }} programme{{ resultsCount !== 1 ? 's': '' }}</strong> found<template v-if="searchTerm"> for "{{ searchTerm }}"</template></p>          
        
          <!-- Clear Filters -->
          <search-clear-filters v-if="isFiltering" link-classes="button button--small bg-bright-blue" />        
        </div>

        <!-- Search Results -->
        <search-results
          :loadingRenderer.prop="loadingRenderer"
          :noResultsRenderer.prop="noResultsRenderer"
        ></search-results>
      </div>

      <!-- Sidebar -->
      <aside class="programmes__aside" role="complementary">

        <!-- Filters -->
        <div class="programmes__filters">
          <SearchFilters 
            :filtersCount="filtersCount"
            :isFiltering="isFiltering"
          />
        </div>
      </aside>
    </section>
  </search-wrapper>
</template>
<script>
  import SearchFilters from './components/SearchFilters.vue'
  import SearchNoResults from './components/SearchNoResults.vue'
  import SearchLoader from './components/SearchLoader.vue'
  import { createApp } from 'vue'
  import { isEmpty } from 'lodash'; 

  export default {
    name: 'App',
    components: {
      SearchFilters
    },
    data() {
      return {
        loadingResults: true,
        postFilters: {},
        ranges: {},
        resultsCount: 0,
        searchTerm: '',
      }
    },
    computed: {

      /*
       * Returns the current window location pathname
       *
       * @returns {string}
       */
      searchUrl() {
        return window.location.pathname
      },

      /*
       * Returns the search payload to provide filters that are executed with the query
       *
       * @returns {string}
       */
      searchPayload() {
        return {
          filters: {
            'Category': ['Course'],
            'StudyLevel': ['Postgraduate'],
            'StudyYear': ['2025'],
          }
        }
      },

      /*
       * Returns whether any filters have been applied
       *
       * @returns {string}
       */
      isFiltering() {
        return !isEmpty(this.postFilters) || !isEmpty(this.ranges)
      },

      /*
       * Returns the number of filters currently applied
       *
       * @returns {Number}
       */
      filtersCount() {

        // Initialise empty variable for storing filter count
        let filtersCount = 0
        
        // Iterate post filters
        Object.values(this.postFilters).forEach((postFilter) => {

          // Append count of this specific filter
          filtersCount += Object.keys(postFilter).length
        })

        // Append the number of ranges applied
        filtersCount += Object.keys(this.ranges).length

        // Return filter count
        return filtersCount
      }
    },
    methods: {

      /*
       * Overrides the default loading renderer by compiling a local Vue template
       *
       * @returns {string}
       */
      loadingRenderer() {
        return createApp(SearchLoader).mount(document.createElement('div')).$el.outerHTML
      },
      
      /*
       * Overrides the default no results renderer by compiling a local Vue template
       *
       * @returns {string}
       */
      noResultsRenderer() {
        return createApp(SearchNoResults, { 
          isFiltering: this.isFiltering,
          searchTerm: this.searchTerm,
        }).mount(document.createElement('div')).$el.outerHTML
      }
    },
    mounted() {

      // Listen for `searchTerm` events and update local component data
      this.$refs.searchWrapper.addEventListener('searchTerm', (event) => {
        this.searchTerm = event.detail
      })

      // Listen for `searchResponse` events and update local component data
      this.$refs.searchWrapper.addEventListener('searchResponse', (event) => {
        this.resultsCount = event.detail.TotalDocument
      })

      // Listen for `loadingResults` events and update local component data
      this.$refs.searchWrapper.addEventListener('loadingResults', (event) => {
        this.loadingResults = event.detail
      })

      // Listen for `postFilters` events and update local component data
      this.$refs.searchWrapper.addEventListener('postFilters', (event) => {
        this.postFilters = event.detail
      })

      // Listen for `ranges` events and update local component data
      this.$refs.searchWrapper.addEventListener('ranges', (event) => {
        this.ranges = event.detail
      })
    }
  }
</script>